import script from "./DueDiligenceRecordChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceRecordChangeView.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceRecordChangeView.vue?vue&type=style&index=0&id=48b7fe8d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b7fe8d"]])

export default __exports__